/* eslint-disable indent, no-param-reassign,no-plusplus, no-unused-vars */
import axios from 'axios';
import cacheAxios from '../../util/cacheAxios';
import MessagingService from '../../centrifugo/chat';

const adminAxios = axios.create();
const cache = new Map();
cacheAxios(adminAxios, cache);

adminAxios.interceptors.response.use(response => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      setTimeout(() => {
        window.location.href = '/sign/in?source=/aims';
      }, 500);
    }
  });

export default {
  state: {
    moduleUsages: [],
    excludeMrc: false,
    identicalCompanies: {},
  },
  mutations: {
    addIdenticalCompanies(state, data) {
      const temp = {
        ...state.identicalCompanies,
        ...data,
      };
      state.identicalCompanies = temp;
    },
    setExcludeMrc(state, v) {
      state.excludeMrc = v;
    },
    setModuleUsage(state, usages) {
      state.moduleUsages = usages;
    },
  },
  actions: {
    saveFinancialIndicators({ state }, { company, dataset }) {
      return adminAxios.post('/aims/api/admin/finance/saveIndicators', {
        companies: state.identicalCompanies[`${company.longName}-${company.exchange}-${company.stockSymbol}`], dataset });
    },
    queryCompanies(_ctx, companies) {
      return adminAxios.post('/aims/api/admin/finance/indicators', companies);
    },
    subscribeToIdenticalCompanies({ rootState, commit }, handleIdenticalCompanies) {
      if (MessagingService.isSubscribed(`identical-company#${rootState.currentUser.userid}`)) {
        return;
      }
      MessagingService.addSubscription(`identical-company#${rootState.currentUser.userid}`, {
        message(dataset) {
          commit('addIdenticalCompanies', dataset.data);
        },
        error(errContext) {
          console.log(`ERROR: ${JSON.stringify(errContext)}`); // eslint-disable-line
        },
      });
    },
    queryFinanceCompanies(_ctx, search) {
      return adminAxios.get(`/aims/api/admin/finance/${search}`);
    },
    postLegislationFiles(ctx, formData) {
      return adminAxios.post('/aims/api/admin/website/legislation', formData);
    },
    postEbiFiles(ctx, formData) {
      return adminAxios.post('/aims/api/admin/website/ebi', formData);
    },
    postEconGuideFiles(ctx, formData) {
      return adminAxios.post('/aims/api/admin/website/econ_guide', formData);
    },
    queryModuleUsage({ commit }, days) {
      adminAxios.get(`/aims/api/admin/moduleUsage/${days}`)
        .then((res) => {
          if (res.data) {
            commit('setModuleUsage', res.data);
          }
        });
    },
    querySalaries(ctx, year) {
      return adminAxios.get(`/aims/api/admin/salaryIncreases/${year}`);
    },
    queryBonus(ctx, year) {
      return adminAxios.get(`/aims/api/admin/bonuses/${year}`);
    },
    queryAttritions(ctx, year) {
      return adminAxios.get(`/aims/api/admin/attritions/${year}`);
    },
    upsertSalary(ctx, { year, country, gicsCode, increment }) {
      return adminAxios.put(`/aims/api/admin/salaryIncreases/${year}/${country}/${gicsCode || ''}`, {
        year, country, gicsCode, increment,
      });
    },
    upsertBonus(ctx, { year, country, bonusType, gicsCode, p25, median, p75, average, count }) {
      return adminAxios.put(
        `/aims/api/admin/bonuses/${year}/${country}/${bonusType}/${gicsCode || ''}`, {
        year, country, bonusType, gicsCode, p25, median, p75, average, count,
      });
    },
    upsertAttrition(ctx, { year, countryCode, gicsCode, p25, p50, p75, noOfCompanies }) {
      return adminAxios.put(`/aims/api/admin/attritions/${year}/${countryCode}/${gicsCode || ''}`, {
        year, countryCode, gicsCode, p25, p50, p75, noOfCompanies,
      });
    },
    deleteSalary(ctx, { year, country, gicsCode }) {
      return adminAxios.delete(`/aims/api/admin/salaryIncreases/${year}/${country}/${gicsCode || ''}`);
    },
    deleteAttrition(ctx, { year, countryCode, gicsCode }) {
      return adminAxios.delete(`/aims/api/admin/attritions/${year}/${countryCode}/${gicsCode || ''}`);
    },
    deleteBonus(ctx, { year, country, bonusType, gicsCode }) {
      return adminAxios.delete(`/aims/api/admin/bonuses/${year}/${country}/${bonusType}/${gicsCode || ''}`);
    },
  },
  getters: {
    moduleUsagesFiltered(state) {
      if (!state.excludeMrc) return state.moduleUsages;
      return state.moduleUsages
      .filter(m => !m.userID.endsWith('mrc-asia.com')
        && !m.userID.endsWith('live.com')
        && !m.userID.endsWith('gmail.com'));
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/adminModule.js